import { makeStyles } from 'tss-react/mui';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import UrlLink from '../url-link';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  meta: {},
  mainIcon: {
    flexShrink: 0,
    marginRight: theme.spacing(0.5),
  },
}));

type Props = {
  event?: Event;
  [key: string]: unknown;
};

const EventLocationOnline = ({ event, ...rest }: Props) => {
  const { classes } = useStyles();

  const { infoUrl } = event;

  if (!infoUrl) {
    return null;
  }

  return (
    <div {...rest} className={classes.root}>
      <LocationOnIcon className={classes.mainIcon} />
      <div>
        <div>Online Event</div>
        <div className={classes.meta}>
          <UrlLink url={infoUrl} />
        </div>
      </div>
    </div>
  );
};

export default EventLocationOnline;
